import {ChartColors} from "../chart/chart-colors"
import {SkinColors} from "../skin-colors"
import {ColorPalette, ItemColorCoding} from "../../../../fields3/color-coding/color-coding"
import {CorePaleBGPaletteLight} from "../palettes/pale-bg/light/core"
import {PriorityPaleBGPaletteLight} from "../palettes/pale-bg/light/priority";
import {StatusPaleBGPaletteLight} from "../palettes/pale-bg/light/status";
import {SystemPaleBgPaletteLight} from "../palettes/pale-bg/light/system";

export class LightSkinColors extends SkinColors {

    get chartColors(): ChartColors {
        return _.assign(super.chartColors, {

            // gridLineColor               : "#00133212",
            gridLineColor               : "#00133212",

            tickLabelColor              : '#787B80',

            burnUpTotalColor            : '#000000',
            burnPlanningLabelColor      : '#000000',
            burnPlanningLabelHaloColor  : 'rgba(255, 255, 255, 0.75)',

            pieStrokeColor              : '#ffffff',
        })
    }

    paleBGColor(colorCoding: ItemColorCoding):string {
        switch (colorCoding.corePalette) {
            case ColorPalette.CORE       : return CorePaleBGPaletteLight[colorCoding.colorNumber]
            case ColorPalette.PRIORITY   : return PriorityPaleBGPaletteLight[colorCoding.colorNumber]
            case ColorPalette.STATUS     : return StatusPaleBGPaletteLight[colorCoding.colorNumber]
            case ColorPalette.SYSTEM     : return SystemPaleBgPaletteLight[colorCoding.colorNumber]
        }

        return '#FF0000'
    }
}